import React from 'react';
import { useStyletron } from 'baseui';
import { BooleanColumn, NumericalColumn, CustomColumn, CategoricalColumn } from 'baseui/data-table';
import _find from 'lodash/find';

import { ZUPEE_GAMES } from 'pages/dashboard/tournamentV2/utils/constants';
import { ECOLOR, EMPTY_STRING } from 'commons-ui';
import { LANG_OPTIONS } from '../../utils/constants';

export const COL_NAMES = {
	code: 'code',
	type: 'type',
	ctaType: 'ctaType',
	ctaValue: 'ctaValue',
	ctaParamsGameName: 'ctaParamsGameName',
	imageRatio: 'imageRatio',
	imageUrl: 'imageUrl',
	isActive: 'isActive',
	language: 'language',
	placementIndex: 'placementIndex',
	minAppVersion: 'minAppVersion',
	maxAppVersion: 'maxAppVersion'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Code',
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.code]
	}),
	CategoricalColumn({
		title: 'Type',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.type]
	}),
	CustomColumn({
		title: 'Is Deployed',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive],
		maxWidth: 200,
		renderCell: (params: any) => {
			const { value } = params;
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: value ? ECOLOR.GREEN : ECOLOR.RED,
						height: '30px',
						width: '100%'
					})}
				/>
			);
		}
	}),
	CategoricalColumn({
		title: 'CTA Type',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.ctaType]
	}),
	CategoricalColumn({
		title: 'CTA Value',
		maxWidth: 600,
		mapDataToValue: (data: any) => data[COL_NAMES.ctaValue] || EMPTY_STRING,
		type: 'string'
	}),
	CategoricalColumn({
		title: 'CTA Params GameName',
		maxWidth: 600,
		mapDataToValue: (data: any) => data[COL_NAMES.ctaParamsGameName] || EMPTY_STRING,
		type: ZUPEE_GAMES
	}),
	NumericalColumn({
		title: 'Image Ratio',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.imageRatio] || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Image',
		minWidth: 400,
		maxWidth: 400,
		mapDataToValue: (data: any) => data[COL_NAMES.imageUrl],
		renderCell: ({ value }: { value: any }) => {
			const [css] = useStyletron();
			return (
				<a href={value} target='_blank' rel='noreferrer'>
					<img src={value} alt='' className={css({ height: '90px' })} />
				</a>
			);
		}
	}),
	NumericalColumn({
		title: 'Min App',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.minAppVersion] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Max App',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.maxAppVersion] || EMPTY_STRING
	}),
	CategoricalColumn({
		title: 'Language',
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			const lang = _find(LANG_OPTIONS, (option: { id: string; label: string }) => option.id === data[COL_NAMES.language]);
			return lang ? lang.label : '';
		}
	}),
	NumericalColumn({
		title: 'Placement Index',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.placementIndex] || 0
	}),
	BooleanColumn({
		title: 'Is Active',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.isActive]
	})
];
